import { useAppflow } from "app/hooks/useAppFlow"
import { Product } from "../Products/types"

export const AppProduct: React.FC<Product> = ({ component: Component }) => {
  const { step } = useAppflow()
  const currentStep = parseInt(step!, 10)

  return <Component currentStep={currentStep} success={false} />
}
